import {
    getNewHistoryRecordsApi,
    getHistoryRecordsApi,
    getDiscoveryHistoryRecordsApi,
    getDiscoveryHistoryExportApi,
    getChemicalHistoryApi,
    getChemicalHistoryCountApi,
    getLoginHistoryRecordsApi,
    deleteAnalyticsHistoryApi,
    deleteChemicalHistoryApi,
    deleteAllDiscoveryExportHistoryApi,
    deleteDiscoveryExportHistoryApi,
    deleteAllDiscoverySearchHistoryApi,
    deleteDiscoverySearchHistoryApi,
} from '../history';
import { discoverSearch, discoverExport, analyticSearch, analyticOther, chemicalFilter, chemicalDbFilter } from '../../utils/dataFilter';


//analytics一层
export function getNewHistoryRecordsApiImpl(params) {
    let keyMap = {};
    return getNewHistoryRecordsApi(params).then(res => {
        return analyticSearch(res, keyMap, true);
    });
}

//analytics两层
export function getHistoryRecordsApiImpl(params) {
    let keyMap = {};
    return getHistoryRecordsApi(params).then(res => {
        return analyticOther(res, keyMap, true);
    });
}

//discovery-search
export function getDiscoveryHistoryApiImpl(params) {
    return getDiscoveryHistoryRecordsApi(params).then(res => {
        return discoverSearch(res);
    });
}
//discovery-export
export function getDiscoveryHistoryExportApiImpl(params) {
    return getDiscoveryHistoryExportApi(params).then(res => {
        return discoverExport(res);
    });
}

//chemical 目前不支持跨域暂时不做区分  //单层
export function getChemicalHistoryApiImpl(params) {
    return new Promise((resolve)=>{
        Promise.all([getChemicalHistoryCountApi(params), getChemicalHistoryApi(params)]).then(res=>{
            let total = res[0].total;
            let data = res[1];
            let keyMap = {};
            data.total = total || 0;
            data = chemicalFilter(data, keyMap, true);
            resolve({
                data
            });
        });
    });
}

//chemical //双层
export function getChemicalDbHistoryApiImpl(params) {
    return new Promise((resolve)=>{
        Promise.all([getChemicalHistoryCountApi(params), getChemicalHistoryApi(params)]).then(res=>{
            let total = res[0].total;
            let data = res[1];
            let keyMap = {};
            data.total = total || 0;
            data = chemicalDbFilter(data, keyMap, false);
            resolve({
                data
            });
        });
    });
}

export function getLoginHistoryRecordsApiImpl(params) {
    return getLoginHistoryRecordsApi(params);
}

/**
 * @projectType 项目类型
 * @currentTab  tab类型
 * @params 接口参数
 * @list
 */
export const getHistoryApiImpl = list => {
    let { projectType, currentTab, params } = list;
    if (projectType === 'analytics') {
        if (currentTab === 'search') {
            return getNewHistoryRecordsApiImpl(params);
        }
        return getHistoryRecordsApiImpl(params);
    }
    if (projectType === 'discovery') {
        if (currentTab === 'search') {
            return getDiscoveryHistoryApiImpl(params);
        }
        return getDiscoveryHistoryExportApiImpl(params);
    }
    if (projectType === 'chemical') {
        if (currentTab === 'search') {
            return getChemicalHistoryApiImpl(params).then(res => {
                return res.data;
            });
        }
        return getChemicalDbHistoryApiImpl(params).then(res => {
            return res.data;
        });
    }
    if (projectType === 'login') {
        return getLoginHistoryRecordsApiImpl(params);
    }
};
/**
 * @projectType 项目类型
 * @currentTab  tab类型
 * @params 接口参数
 * @list
 */
export const deleteHistoryApiImpl = list => {
    let { projectType, currentTab, deleteAll, params } = list;
    if (projectType === 'analytics' || projectType === 'login') {
        return deleteAnalyticsHistoryApi(params);
    }
    if (projectType === 'chemical') {
        return deleteChemicalHistoryApi(params);
    }
    if (projectType === 'discovery') {
        if (currentTab === 'export') {
            return deleteAll ? deleteAllDiscoveryExportHistoryApi() : deleteDiscoveryExportHistoryApi(params);
        }
        return deleteAll ? deleteAllDiscoverySearchHistoryApi() : deleteDiscoverySearchHistoryApi(params);
    }
};
